export default __webpack_public_path__ + "static/media/august2023-3.b07e22e7.jpg";